import equalByNameAndAssetComponentId from '../../utils/equalByNameAndAssetComponentId';
import {i18n} from "../../../vue-i18n";

export default class ChangeIsPermanent {
  constructor(assetComponentId, newIsPermanent) {
    this.commandName = "ChangeIsPermanent";

    this.assetComponentId = assetComponentId;
    this.newIsPermanent = newIsPermanent;

    if (this.newIsPermanent) {
      this.description =
        `${i18n.t('CONTENT.events.set_perpetual')}`;
    } else {
      this.description =
        `${i18n.t('CONTENT.events.remove_perpetual')}`;
    }
  }

  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: JSON.stringify({
        AssetComponentId: this.assetComponentId,
        NewIsPermanent: this.newIsPermanent
      })
    }
  }

  equal = (other) => equalByNameAndAssetComponentId(this, other);
}
